import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";
/* istanbul ignore file */

export const getGebruikersgroepenTextResources = createGetTextResources({
  groepsNaam: "Vul alsjeblieft een naam in.",
  uniekNaam: "Gebruikersgroep naam is niet uniek"
});
